import React, { useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './controlPanel.css';
import CalendarBtn from '../../../../../statistics/controlPanel/calendarBtn/CalendarBtn';
import DeleteStatisticsData from './deleteStatisticsData/DeleteStatisticsData';
import { NavLink } from 'react-router-dom';
import EmailBtn from './emailBtn/EmailBtn';
import ReportSetup from './reportSetup/ReportSetup';
import ProtectedComponent from '../../../../../../components/protectedComponent/ProtectedComponent';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ControlPanel = () => {
    const { calendar, localization: { content } } = useSelector( state => state );
    const [ deleteStatisticsPopup, setDeleteStatisticsPopup ] = useState( false );
    const activeUrl =  window.location.href.split( '/' ).reverse()[ 0 ] || '' ;
    const openPopupDeleteStatisticsData = () => setDeleteStatisticsPopup( true );
    const closePopupDeleteStatisticsData = () => setDeleteStatisticsPopup( false );
    const activeLinkStyle = { opacity: 1 };
    const initialState = {
        showReportSetupForm: false
    };

    const reducer = ( state = initialState, action ) => {

        switch ( action.type ) {
            case 'ADD-DATA': {
                return { ...state, ...action.data };
            }
            default:
                return state;
        }
    };
    const initial = state => state;
    const [ data, dispatch ] = useReducer( reducer, initialState, initial );
    const { showReportSetupForm } = data;

    const showReportSetup = () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                showReportSetupForm: true
            }
        } );
    };

    const closeReportSetup = () => {
        dispatch( {
            type: 'ADD-DATA', data: {
                showReportSetupForm: false
            }
        } );
    };

    return (
        <nav className={ styles.wrapper }>
            <div className={ styles.panel }>
                <ul className={ styles.menu }>
                    <li className={ styles.menuBottom }>

                        <NavLink className={ styles.link }
                                 to={ `/calendar/${ calendar.id }/statistics/overall` }
                                 style={ activeUrl === 'overall' ? activeLinkStyle : {} }
                        >
                            { content.calendar.overall }
                        </NavLink>

                    </li>
                    <li className={ styles.menuBottom }>

                        <NavLink className={ styles.link }
                                 to={ `/calendar/${ calendar.id }/statistics/country` }
                                 style={ activeUrl === 'country' ? activeLinkStyle : {} }
                        >
                            { content.calendar.country }
                        </NavLink>

                    </li>

                    <li className={ styles.menuBottom }>
                        <NavLink className={ styles.link }
                                 to={ `/calendar/${ calendar.id }/statistics/questions` }
                                 style={ activeUrl === 'questions' ? activeLinkStyle : {} }
                        >
                            { content.calendar.question }
                        </NavLink>
                    </li>
                    <ProtectedComponent permissions={['quiz_settings']}>
                    <li>
                        <EmailBtn onclick={ showReportSetup } caption={ `${ content.quiz.statistics.mail_report }` }/>
                    </li>
                    </ProtectedComponent>

                    <li>
                        <CalendarBtn onclick={ null }
                                     caption={ `${ content.quiz.players.last }3${ content.quiz.players.months }` }/>

                    </li>

                </ul>
            </div>
            <ProtectedComponent permissions={['quiz_settings']}>
            <button onClick={ openPopupDeleteStatisticsData } className={ styles.data }>
                { content.quiz.players.delete_all_data }
            </button>
            </ProtectedComponent>
            { deleteStatisticsPopup &&
            <DeleteStatisticsData
                closePopupDeleteStatisticsData={ closePopupDeleteStatisticsData }
                content={ content }
                calendarID={ calendar.id }
            />
            }
            { showReportSetupForm && <ReportSetup closeForm = { closeReportSetup } /> }
        </nav>
    );

};

export default ControlPanel;